// src/pages/Login.jsx
import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SIGNUP_CLOSED } from '../utils/siteMode.js';
import toast from 'react-hot-toast';

import SEO from '../components/SEO.jsx';
import InAppBrowserNotice from '../components/InAppBrowserNotice.jsx';
import SocialButtons from '../components/SocialButtons.jsx';
import { useAuth } from '../hooks/useAuth.js';
import { useCountry } from '../contexts/CountryContext.jsx';

export default function Login() {
  const { t } = useTranslation();
  const { user, profile, profileLoaded, socialBusy, socialError } = useAuth();
  const { country } = useCountry();
  const navigate = useNavigate();
  const location = useLocation();
  const redirectTo = location.state?.from ?? '/dashboard';

  // 소셜 리다이렉트 복귀 또는 세션 유지 진입 → 인증+프로필 확인되면 이동.
  useEffect(() => {
    if (user && profileLoaded && profile) navigate(redirectTo, { replace: true });
  }, [user, profile, profileLoaded, redirectTo, navigate]);

  useEffect(() => {
    if (socialError) toast.error(socialError);
  }, [socialError]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4">
      <SEO title={t('auth.login')} description={t('auth.loginSeoDesc')} path="/login" noIndex />
      <Link to="/" className="mb-4 text-sm text-gray-500 hover:text-gray-800">← {t('nav.home')}</Link>
      <InAppBrowserNotice />
      <div className="card w-full max-w-md text-center">
        <h1 className="text-2xl font-bold mb-2">{t('auth.login')}</h1>
        <p className="text-sm text-gray-500 mb-6">{t('appName')}</p>

        {socialBusy ? (
          <p className="py-6 text-sm text-gray-500">…</p>
        ) : (
          <SocialButtons country={country} />
        )}

        {/* 신규 가입 종료 (2026-08-28, utils/siteMode.js) — 가입 링크를 숨긴다.
            기존 계정 로그인은 그대로 열려 있다. */}
        {!SIGNUP_CLOSED && (
          <p className="text-center mt-6 text-sm text-gray-600">
            <Link to="/register" className="font-semibold" style={{ color: 'var(--color-primary)' }}>
              {t('auth.signup')} →
            </Link>
          </p>
        )}
      </div>
    </div>
  );
}
